import { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { show } from '../../slices/toastSlice';
import { fetchRequests } from '../../Requests/getRequests';
import { authStaff } from '../../utils/constants';
import { selectAccessToken } from '../../slices/staffSlice';
import { HugeiconsIcon } from '@hugeicons/react';
import { CheckmarkCircle01Icon, SmartPhone01Icon } from '@hugeicons/core-free-icons';

function VerifyClient() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const accessToken = useSelector(selectAccessToken);
    const [phone, setPhone] = useState("");
    const [network, setNetwork] = useState("");
    const [processing, setProcessing] = useState(false);
    const [result, setResult] = useState(null);

    const handleSearch = async (e) => {
        e.preventDefault();
        setProcessing(true);

        if (phone === "" || network === "") {
            setProcessing(false);
            dispatch(show({ type: "error", state: true, message: "Please enter a phone number and select a network" }));
            return;
        }

        let res = await fetchRequests(`/payments/staff/verify-client`, "GET", authStaff(accessToken), { phone, network }, {});
        setProcessing(false);

        if (res?.code === 401) {
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
            return;
        }
        if (res?.err) {
            dispatch(show({ type: "error", state: true, message: `${res?.err}` }));
            return;
        }

        setResult(res);
    };

    return (
        <div className='section-container md:py-2 py-0'>
            <div className='bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-xl shadow-sm p-6'>
                <div className='mb-5'>
                    <h2 className='text-base font-semibold text-gray-900 dark:text-gray-50'>Verify MoMo Number</h2>
                    <p className='text-sm text-gray-500 dark:text-gray-400 mt-0.5'>Confirm a mobile money account is active and registered.</p>
                </div>

                <form className='flex flex-wrap gap-3 items-end' onSubmit={handleSearch}>
                    <div className='flex-1 min-w-48'>
                        <label htmlFor="momo-phone" className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">
                            Phone Number
                        </label>
                        <input
                            type="text"
                            name="momo-phone"
                            id="momo-phone"
                            className='form-input'
                            placeholder='e.g. 0244000000'
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            required
                        />
                    </div>
                    <div className='flex-1 min-w-48'>
                        <label htmlFor="network-filter" className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">
                            Network
                        </label>
                        <select
                            name="network-filter"
                            id="network-filter"
                            className='form-input'
                            required
                            onChange={(e) => setNetwork(e.target.value)}
                        >
                            <option value="">-- select --</option>
                            <option value="mtn">MTN</option>
                        </select>
                    </div>
                    <button
                        type="submit"
                        disabled={processing}
                        className='flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium text-white transition-colors disabled:opacity-60'
                        style={{ backgroundColor: '#1e3a6e' }}
                    >
                        <HugeiconsIcon icon={CheckmarkCircle01Icon} size={16} />
                        {processing ? 'Verifying…' : 'Verify'}
                    </button>
                </form>

                {result?.given_name && (
                    <div className='mt-6'>
                        <p className='text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3'>Verification Result</p>
                        <div className='flex items-center gap-3 px-4 py-3.5 bg-emerald-50 border border-emerald-100 rounded-lg'>
                            <div className='w-9 h-9 rounded-full bg-emerald-100 flex items-center justify-center shrink-0'>
                                <HugeiconsIcon icon={SmartPhone01Icon} size={18} className='text-emerald-600' />
                            </div>
                            <div>
                                <p className='text-sm font-semibold text-gray-900'>
                                    {result.given_name} {result.family_name}
                                </p>
                                <p className='text-xs text-emerald-700 font-medium uppercase'>{network} · Verified</p>
                            </div>
                            <HugeiconsIcon icon={CheckmarkCircle01Icon} size={20} className='text-emerald-500 ml-auto shrink-0' />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default VerifyClient;
